import type { ParceiroPorDocumentoResponse } from '@triade/contracts';
import { ApiError } from '@/lib/api';
import { useConsulta } from './base';

/**
 * "Este CPF/CNPJ ja esta cadastrado?" (GET /parceiros/por-documento). So consulta com documento valido (digitos).
 * `documento` null = nao consulta. Quem chama confere se o resultado e do documento atual.
 */
export function useParceiroPorDocumento(documento: string | null) {
  return useConsulta<ParceiroPorDocumentoResponse>(['parceiros', 'por-documento'], '/parceiros/por-documento', {
    query: { documento: documento ?? undefined },
    ativo: documento !== null,
  });
}

/** 409 DOCUMENTO_JA_CADASTRADO ao gravar: devolve o nome do cadastro que ja tem o documento (null = outro erro). */
export function conflitoDocumento(e: unknown): { nome: string } | null {
  if (!(e instanceof ApiError) || e.code !== 'DOCUMENTO_JA_CADASTRADO') return null;
  const det = e.body?.details as { nome?: unknown } | undefined;
  return { nome: typeof det?.nome === 'string' ? det.nome : 'outro cadastro' };
}
